import { Component } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { KeycloakInfoService } from '../../services/keycloak-info.service';
import { PageTitleComponent } from '../../ui/page-title/page-title.component';

import { OtherComponent } from './other/other.component';
import { EnglishComponent } from './english/english.component';

@Component({
  selector: 'rqa-help',

  template: `
    <div class="card">
      <rqa-page-title [title]="'help.title' | translate"> </rqa-page-title>
      <p-tabs [(value)]="activeTab">
        <p-tablist>
          <p-tab value="0">{{ 'help.english' | translate }}</p-tab>

          <p-tab value="1">{{ 'help.polish' | translate }}</p-tab>
        </p-tablist>

        <p-tabpanels>
          <p-tabpanel value="0">
            <rqa-english *ngIf="activeTab === '0'"></rqa-english>
          </p-tabpanel>

          <p-tabpanel value="1">
            <rqa-other *ngIf="activeTab === '1'" [locale]="'PL'"></rqa-other>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </div>
  `,

  imports: [TabsModule, OtherComponent, EnglishComponent, CommonModule, PageTitleComponent, TranslateModule],

  standalone: true
})
export class HelpComponent {
  locale = this.keycloakInfo.locale;

  activeTab: string = '0';

  constructor(private keycloakInfo: KeycloakInfoService) {}
}
